module.exports = __webpack_public_path__ + "img/symbol_17.5f29d8c3.png";